<script setup>
import {computed} from 'vue'
import {useFormStore} from '@/stores/form'
import moment from "moment/moment"

import UserAvatar from "@/common/UserAvatar.vue"
import UserName from "@/common/UserName.vue"
import FormHistoryOffcanvas from "@/common/form/FormHistoryOffcanvas.vue"

const props = defineProps({
    formId: String
})

const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

const currentData = computed(() => formStore.value?.currentData || {})

const getDate = (timestamp) => {
    return moment(timestamp).format('DD MMM YYYY @ HH:mm')
}
</script>

<template>
    <div class="list-group list-group-flush">
        <a data-bs-toggle="offcanvas" role="button" data-bs-target="#historyOffcanvas" v-if="currentData.modifiedDate"
           class="list-group-item list-group-item-action border-bottom-0 d-flex align-items-start px-2 py-1 small">
            <UserAvatar v-if="currentData.modifiedBy" :user-id="currentData.modifiedBy" :is-small="false"
                        :tooltip-placement="'right'" class="mt-1 me-2"/>

            <small>
                <UserName v-if="currentData.modifiedBy" :id="currentData.modifiedBy"
                          :no-user-found-str="'<em>user not found</em>'"/>
                <br>
                {{ getDate(currentData.modifiedDate * 1000) }}
            </small>
        </a>

        <FormHistoryOffcanvas :form-id="formId"/>
    </div>
</template>